/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { modalContentStyles, partnersSpeakStyles } from "./styles";
import { PartnersSpeakProps, Testimonials } from "./interfaces";
import { ResponsiveWidget, ResponsiveWidgetItem } from "../ResponsiveWidget";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { GAEvents, PropValuesEnum } from "../../constants/commons";
import { LinkButton } from "../../atoms/LinkButton";
import { Video } from "../Video";
import Carousel from "react-multi-carousel";
import { useSTR } from "react-str";
import { URL } from "../../API/urlEndpoints";
import { getData } from "../../utils/fetchers";
import "react-multi-carousel/lib/styles.css";
import { ErrorComponent } from "../../molecules/ErrorComponent";
import { Modal } from "../../atoms/Modal";
import { ModalSizeType } from "../../atoms/Modal/interface";
import { GA_Event } from "../../utils/reactGA";

export const PartnersSpeak: React.FunctionComponent<PartnersSpeakProps> = (
  props
) => {
  const { cardBgColor, carouselViewBreakpoints, profession } = props;
  const [cfTestimonials, setCFTestimonials] = React.useState<
    Array<Testimonials>
  >([]);
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [modalContent, setModalContent] = React.useState<Testimonials>();
  const isMobile = useIsMobile();
  const isTablet = useIsTab();

  const [
    ,
    {
      result: getTestimonialsResult,
      revalidator: refetchTestimonials,
      loading: testimonialsIsLoading,
      error: testimonialsFetchError,
    },
  ] = useSTR(getData);

  React.useEffect(() => {
    refetchTestimonials(`${URL.getTestimonialsData(profession)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (getTestimonialsResult && getTestimonialsResult.length) {
      setCFTestimonials(getTestimonialsResult);
    }
  }, [getTestimonialsResult]);

  const handleReadMore = (item: Testimonials) => {
    setShowModal(true);
    setModalContent(item);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const getPartnerDetails = (words: number) => {
    return cfTestimonials.map((item, key) => {
      return (
        <div className="carousel-data-container" key={key}>
          <ResponsiveWidgetItem cardView>
            <div className="video-container">
              {item.videoUrl ? (
                <Video videoUrl={item.videoUrl} />
              ) : (
                <img
                  className="author-img"
                  src={item.imgUrl}
                  alt="Author Img"
                />
              )}
            </div>
            <div>
              <h3>{item.heading}</h3>
              <div className="name-container">
                <h5>- {item.author}</h5>
                <span>{item.profession.toLowerCase()}</span>
              </div>
              <div className="text-container">
                <span>
                  {item.body.substring(0, words)}{" "}
                  {item.body.substring(words, words + 1) ? "....." : ""}
                </span>
                {item.body.substring(words, words + 1) && (
                  <LinkButton onClick={() => handleReadMore(item)}>
                    Read more
                  </LinkButton>
                )}
              </div>
            </div>
          </ResponsiveWidgetItem>
        </div>
      );
    });
  };

  const responsiveVideoCarousel = {
    ...carouselViewBreakpoints,
    tablet: {
      breakpoint: { max: 885, min: 615 },
      items: 1,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 615, min: 0 },
      items: 1,
      partialVisibilityGutter: 0,
    },
  };

  return (
    <React.Fragment>
      {(!!cfTestimonials.length ||
        testimonialsIsLoading ||
        testimonialsFetchError) && (
        <React.Fragment>
          <div className="header-container mb-4">
            <h5>Partners Speak</h5>
          </div>
          {testimonialsFetchError && (
            <ErrorComponent errorObj={testimonialsFetchError} />
          )}
          {!testimonialsIsLoading && !!cfTestimonials.length && (
            <React.Fragment>
              {isMobile || isTablet ? (
                <ResponsiveWidget
                  align={PropValuesEnum.HORIZONTAL}
                  css={partnersSpeakStyles(true, cardBgColor)}
                >
                  {getPartnerDetails(200)}
                </ResponsiveWidget>
              ) : (
                <Carousel
                  responsive={responsiveVideoCarousel}
                  arrows
                  showDots
                  partialVisible
                  css={partnersSpeakStyles(false, cardBgColor)}
                  beforeChange={() => {
                    GA_Event(
                      GAEvents.PARTNERS_SPEAK,
                      "scrolled",
                      "from carousel"
                    );
                  }}
                >
                  {getPartnerDetails(800)}
                </Carousel>
              )}
            </React.Fragment>
          )}
          {testimonialsIsLoading && <div className="loader" />}
          {showModal && (
            <Modal
              showCloseIcon
              closeModal={closeModal}
              modalSize={isMobile ? ModalSizeType.LARGE : ModalSizeType.MEDIUM}
              css={modalContentStyles(isMobile ? true : false)}
            >
              <div className="modal-pop-up-content">
                <h3>{modalContent?.heading}</h3>
                <div className="name-container">
                  <h5>- {modalContent?.author}</h5>
                  <span>{modalContent?.profession.toLowerCase()}</span>
                </div>
                <div className="text-container">
                  <span>{modalContent?.body}</span>
                </div>
              </div>
            </Modal>
          )}
        </React.Fragment>
      )}
      {/* {!testimonialsIsLoading &&
        !testimonialsFetchError &&
        !cfTestimonials.length && (
          <div>No Testimonals available at the moment !</div>
        )} */}
    </React.Fragment>
  );
};
